export const isLoading = (state) => state.loading
export const getSuppliers = (state) => state.suppliers
export const getProducts = (state) => state.products
export const getSupplyDetail = (state) => state.supplyDetail
export const getSupplyStatuses = (state) => state.supplyStatuses
